// ─── Stockist Click Events ───────────────────────────────────────────────────
(function () {
  document.addEventListener('click', function (event) {
    var target = event.target;

    if (target.matches('.stockist-result-phone a')) {
      Shopify.analytics.publish('stockist_phone_clicked', {
        phone_number: target.getAttribute('href'),
        link_text: target.textContent.trim(),
        timestamp: new Date().toISOString()
      });
    } else if (target.matches('.stockist-result-email a')) {
      Shopify.analytics.publish('stockist_email_clicked', {
        email: target.getAttribute('href'),
        link_text: target.textContent.trim(),
        timestamp: new Date().toISOString()
      });
    } else if (target.matches('.stockist-result-website a')) {
      Shopify.analytics.publish('stockist_website_clicked', {
        website_url: target.getAttribute('href'),
        link_text: target.textContent.trim(),
        timestamp: new Date().toISOString()
      });
    }
  });
})();


// ─── postMessage Listener (Hulk Forms) ───────────────────────────────────────
(function () {

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  window.addEventListener('message', function (event) {
    if (!event.data || !event.data.type) return;

    // Reply with parent URL
    if (event.data.type === 'get-parent-url') {
      event.source.postMessage({
        type: 'parent-url',
        pathname: window.location.pathname
      }, '*');
    }

    // Reply with appointment cookie
    if (event.data.type === 'get-appointment-cookie') {
      event.source.postMessage({
        type: 'appointment-cookie',
        appointmentType: getCookie('mm-store-appointment')
      }, '*');
    }

    // Private consultation / the house
    if (
      event.data.type === 'private-consultation-booked' ||
      event.data.type === 'the-house-form-submit'
    ) {
      Shopify.analytics.publish(event.data.type, {
        timestamp: event.data.timestamp
      });
    }

    // Appointment form events
    if (
      event.data.type === 'diamond_expert_submitted' ||
      event.data.type === 'request_service_submitted'
    ) {
      Shopify.analytics.publish(event.data.type, {
        appointment_type: event.data.detail.appointment_type,
        timestamp: event.data.detail.timestamp
      });
    }

    if (event.data.type === 'virtual_appointment_booked') {
      Shopify.analytics.publish('virtual_appointment_booked', {
        timestamp: event.data.detail.timestamp
      });
    }

  });

})();


// ─── Reserve Your Ring ────────────────────────────────────────────────────────
(function () {
  if (!window.location.pathname.includes('/products/')) return;

  document.addEventListener('submit', (event) => {
    const productForm = event.target.closest?.('.product-form');
    if (!productForm) return;

    const reserveButton = productForm.querySelector('[data-reserve-your-ring]');
    if (!reserveButton) return;

    Shopify.analytics.publish('reserve_your_ring', {
      timestamp: new Date().toISOString()
    });
  });
})();